export const transactionTitles = {
  "transfer-sent": "转账已发送",
  "transfer-received": "转账已接收",
  withdrawal: "提款",
  deposit: "存款",
  "parley-rebate": "Parley 10% 返现",
  "morning-promotion-award": "晨间存款促销",
  "betby-bet": "Betby - 投注失败",
  "betby-win": "Betby - 投注获胜",
  "betby-refund": "Betby - 投注退款",
  "pixmove-bet": "Pixmove - 投注失败",
  "pixmove-win": "Pixmove - 投注获胜",
  "pixmove-rollback": "Pixmove - 投注退款",
  "pragmatic-bet": "Pragmatic - 投注失败",
  "pragmatic-win": "Pragmatic - 投注获胜",
  "pragmatic-refund": "Pragmatic - 投注退款",
  "hacksaw-rollback": "Hacksaw - 投注退款",
  "hacksaw-win": "Hacksaw - 投注获胜",
  "hacksaw-bet": "Hacksaw - 投注失败",
  "kaga-win": "Kaga - 投注获胜",
  "kaga-bet": "Kaga - 投注失败",
  "gamingcorps-bet": "Gamingcorps - 投注失败",
  "gamingcorps-win": "Gamingcorps - 投注获胜",
  "gamingcorps-refund": "Gamingcorps - 投注退款",
  "bgaming-lost": "BGaming - 投注失败",
  "bgaming-win": "BGaming - 投注获胜",
  "bgaming-bet": "BGaming - 投注失败",
  "bgaming-refund": "BGaming - 投注退款",
  "upgaming-bet": "Upgaming - 投注失败",
  "upgaming-win": "Upgaming - 投注获胜",
  "upgaming-lost": "Upgaming - 投注失败",
  "upgaming-refund": "Upgaming - 投注退款",
  "pragmatic-adjustment": "Pragmatic - 调整",
  "lottery-ticket-purchase": "彩票已购买",
  "lottery-winnings": "彩票中奖",
};
